export default "__VITE_ASSET__ChpGNg13__"